import { render, staticRenderFns } from "./commissionRuleExtra.vue?vue&type=template&id=914855f4"
import script from "./commissionRuleExtra.vue?vue&type=script&lang=js"
export * from "./commissionRuleExtra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports